// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1JpH9","notes":"Notes_notes__q-oIs"};